import dayjs from "dayjs";
import { useMemo } from "react";

import { TIME_FORMAT } from "./consts";
import { UseTimePickerField } from "./types";

export const useTimePickerField: UseTimePickerField = ({ value, onChange }) =>
  useMemo(
    () => ({
      value: value ? dayjs(value, TIME_FORMAT) : null,
      onChange(newValue) {
        onChange?.(newValue?.format(TIME_FORMAT));
      },
    }),
    [onChange, value]
  );
